import { buildCustomerSupportLink, getVB6SiteOrigin } from "functions/v1/navigation/utilitiesFunctions";
import { UserInfoContext } from "GlobalContextProviders";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { HelpCenterLinksProps } from "types/v1/navigation/layoutTypes";
import { isDiversityUserType, isVendorUserType } from "types/v1/security/userAccessTypes";
import { buildHelpCenterLink } from "functions/v1/navigation/utilitiesFunctions";

const HelpCenterLinks = (props: HelpCenterLinksProps) => {

    const origin = getVB6SiteOrigin();
    const userAccess = useContext(UserInfoContext); // Get the user access stuff
    const helpCenterLink = origin + "/SecureLogin/ZendeskSSO.aspx";
    const location = useLocation(); // Get the current url information

    const defaultSupportLinkOnly = () => {
        // Check the path for a module with special support links
        if (location.pathname.startsWith("/vss/")) {
            return false;
        }
        return true;
    }

    return(
        <>
        {(userAccess === undefined) ? (
            /* Show Loading when Needed */
            <ul id="help_menu_options" className={props.isMenuActive(props.isHelpMenuVisible)} role="menu" aria-label="Help Menu Options" aria-expanded={props.isHelpMenuVisible}>
                <li id="help_menu_header"><h4 className="b2g_support_menu_title margin_0" tabIndex={-1}>Loading Help Center...</h4></li>
            </ul>
        ) : (
            /* Display Links if Ready */
            <ul id="help_menu_options" className={props.isMenuActive(props.isHelpMenuVisible)} role="menu" aria-label="Help Menu Options" aria-expanded={props.isHelpMenuVisible}>
                <li id="help_menu_header"><h4 className="b2g_support_menu_title margin_0" tabIndex={-1}>Help Center</h4></li>
                { !defaultSupportLinkOnly() &&
                <>
                    <li id="faq_option">
                        <a href={buildHelpCenterLink("faq", userAccess, location)} target="_blank" role="menuitem">How-To Articles, Guides and FAQs</a>
                    </li>
                    <li id="release_notes_option">
                        <a href={buildHelpCenterLink("releaseNotes", userAccess, location)} target="_blank" role="menuitem">See What’s New</a>
                    </li>
                </>
                }
                <li id="contact_customer_support_option">
                    <a href={buildCustomerSupportLink(userAccess)} target="_blank" role="menuitem">Submit a Support Ticket</a>
                </li>
                <li id="help_center_option">
                    <a href={buildHelpCenterLink("", userAccess, location)} target="_blank" role="menuitem"><strong className="text-red">NEW!</strong> Help Center</a>
                </li>
            </ul>
        )}
        </>
    )
}

export default HelpCenterLinks;

